import Template1 from "./Template1DarkCard";
import "../../../css/offerTemplates.css";
import Template2Food from "./Template2Food";

export default function OfferTemplateRenderer({
	data,
	type,
	previewUrl,
	distanceKm,
}) {
	switch (type) {
		case "dark":
			return (
				<Template1
					data={data}
					previewUrl={previewUrl}
					distanceKm={distanceKm}
				/>
			);
		case "food":
			return (
				<Template2Food
					data={data}
					previewUrl={previewUrl}
					distanceKm={distanceKm}
				/>
			);
		default:
			return <Template1 data={data} />;
	}
}
